import { useInvalidate, useOne, useParsed } from '@refinedev/core';
import { useCurrentClient } from 'src/clients/context/CurrentClientProvider';
import { DetectResponse } from '../../types';
import { Params } from 'react-router-dom';

type UseDetectionsProps = {
  fileId?: string;
};

export function useInvalidateDetections() {
  const { params } = useParsed<Params>();
  const { clientId } = useCurrentClient();
  const fileId = params?.fileId ?? '';

  const invalidate = useInvalidate();

  const invalidateDetections = () =>
    invalidate({
      resource: `clients/${clientId}/data-upload-files/${fileId}`,
      invalidates: ['detail'],
      id: 'detections',
    });

  return {
    invalidateDetections,
  };
}

export function useDetections({ fileId }: UseDetectionsProps) {
  const { clientId } = useCurrentClient();
  const { data, isLoading, isFetching, isError, error, refetch } = useOne<DetectResponse>({
    resource: `clients/${clientId}/data-upload-files/${fileId}`,
    id: 'detections',
    queryOptions: {
      enabled: !!clientId && !!fileId,
      staleTime: Infinity,
    },
  });

  return {
    detections: data?.data?.detections || [],
    isLoading,
    isFetching,
    isError,
    error,
    refetchDetections: refetch,
  };
}
